import { render, staticRenderFns } from "./CalcIssueDetail.vue?vue&type=template&id=40665315&scoped=true"
import script from "./CalcIssueDetail.vue?vue&type=script&lang=js"
export * from "./CalcIssueDetail.vue?vue&type=script&lang=js"
import style0 from "./CalcIssueDetail.vue?vue&type=style&index=0&id=40665315&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40665315",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40665315')) {
      api.createRecord('40665315', component.options)
    } else {
      api.reload('40665315', component.options)
    }
    module.hot.accept("./CalcIssueDetail.vue?vue&type=template&id=40665315&scoped=true", function () {
      api.rerender('40665315', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/settle/CalcIssueDetail.vue"
export default component.exports